import { FileCode, Database, Loader2, AlertCircle } from 'lucide-react';

const InputSection = ({
  onXmlUpload,
  onCsvUpload,
  loading,
  error,
  routesInDb,
  uniqueCBs,
  uploadingCsv
}) => {
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6 space-y-4">
      <div className="grid grid-cols-2 gap-6">
        {/* SWIFT XML Upload */}
        <div className="space-y-3 flex flex-col">
          <h3 className="text-sm font-semibold uppercase tracking-widest text-slate-500">SWIFT Messages</h3>
          <p className="text-xs text-slate-600 flex-grow">Upload pacs.008/pacs.009 XML files (single or multiple)</p>
          
          <label
            data-testid="xml-upload-label"
            className="w-full bg-sky-600 text-white hover:bg-sky-700 text-sm px-4 py-3 rounded-md font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <FileCode className="w-4 h-4" />
            Upload SWIFT XML
            <input
              data-testid="xml-upload"
              type="file"
              accept=".xml"
              onChange={onXmlUpload}
              className="hidden"
            />
          </label>
        </div>

        {/* CB Routes Database Upload */}
        <div className="space-y-3 flex flex-col">
          <h3 className="text-sm font-semibold uppercase tracking-widest text-slate-500">Routes Database</h3>
          <p className="text-xs text-slate-600 flex-grow">
            {uniqueCBs > 0 ? `Alternate routes for ${uniqueCBs} CBs loaded` : 'No routes in database'}
          </p>
          
          <label
            data-testid="csv-upload-label"
            className="w-full bg-emerald-600 text-white hover:bg-emerald-700 text-sm px-4 py-3 rounded-md font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-2"
          >
            {uploadingCsv ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Uploading...
              </>
            ) : (
              <>
                <Database className="w-4 h-4" />
                Upload CB Routes CSV
              </>
            )}
            <input
              data-testid="csv-upload"
              type="file"
              accept=".csv"
              onChange={onCsvUpload}
              className="hidden"
              disabled={uploadingCsv}
            />
          </label>
        </div>
      </div>

      {loading && (
        <div className="flex items-center justify-center gap-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <Loader2 className="w-4 h-4 animate-spin text-blue-600" />
          <p className="text-xs text-blue-700">Finding optimal route from xGBoost API...</p>
        </div>
      )}

      {error && (
        <div className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-md" data-testid="error-message">
          <AlertCircle className="w-4 h-4 text-red-600 shrink-0 mt-0.5" />
          <p className="text-xs text-red-700">{error}</p>
        </div>
      )}
    </div>
  );
};

export default InputSection;
